<table data-test="13quxua8" class="items-table" [ngClass]="tableClasses">
  <colgroup data-test="gd5mm28G" *ngIf="colWidths">
    <!--suppress HtmlDeprecatedAttribute -->
    <col data-test="10ZS6-Pq" *ngFor="let colWidth of colWidths" [width]="colWidth" />
  </colgroup>
  <thead data-test="_AEo7qUb">
    <ng-content select=">tr[md-table-header]"></ng-content>
  </thead>
  <tbody data-test="Fp-poRGm">
    <ng-content select=">tr:not([md-table-header]),>[md-table-row]"></ng-content>
  </tbody>
</table>
